import { h } from 'preact'
import { ProductAreaType } from '../../product-areas/ProductAreaSelect'
import Phrase from '../../../libs/translationsUtils/phrase'

interface Props {
  productAreas: Array<ProductAreaType>,
  onCallback: (status: string | null) => void,
  selected: null | string
}

const ProductAreaFilter = ({ productAreas, selected, onCallback }: Props) => {
  return (
    <div className='box__content box__pad ideation-filters'>
      <h3 className='widget-title'><Phrase p='filter.by.product' /></h3>
      <ul className='ideation-filters__product-area'>
        <li className={selected === null ? 'selected' : ''} onClick={() => onCallback(null)}>
          <div className='vertical-line' />
          <span>All products</span>
        </li>
        {
          productAreas.map(({ name }) => (

            <li className={selected === name ? 'selected' : ''} onClick={() => onCallback(name)}>
              <div className='vertical-line' />
              <span>{ name }</span>
            </li>
          ))
        }
      </ul>
    </div>
  )
}

export default ProductAreaFilter
